export function forEach(array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]);
  }
}

export function hasTouch() {
  return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
}
